import platform, { appVersion } from '@/shared/utils/platform';
import { versionCompare } from '@/shared/utils/versionCompare';

/**
 * 安卓OCR 识别支持最低版本，在应用启动时下载OCR SDK
 * 从6.75.5开始，移除启动时下载OCR SDK，改为由业务调用下载优先级API自行下载OCR SDK
 * */
const OCR_SUPPORT_ANDROID_APP_VERSION = '6.74.0';
/** IOS OCR 识别支持最低版本 */
const OCR_SUPPORT_IOS_APP_VERSION = '6.81.0';
/** 安卓动态资源下载优先级API 支持APP最低版本 */
const OCR_FIRST_SUPPORT_ANDROID_APP_VERSION = '6.75.5';

/** Android 可以使用客户端 OCR 识别的环境 */
export const canAndroidOcrUse = platform.isAndroid
  && (platform.isEasyBike || platform.isSkzhenxhApp)
  && versionCompare(appVersion, OCR_SUPPORT_ANDROID_APP_VERSION) >= 0;

/** 是否可使用 安卓动态资源下载优先级API */
export const canDownloadFirstUse = platform.isAndroid
  && (platform.isEasyBike || platform.isSkzhenxhApp)
  && versionCompare(appVersion, OCR_FIRST_SUPPORT_ANDROID_APP_VERSION) >= 0;

/** IOS 可以使用客户端 OCR 识别的环境 */
export const canIOSOcrUse = platform.isIOS
  && (platform.isEasyBike || platform.isSkzhenxhApp)
  && versionCompare(appVersion, OCR_SUPPORT_IOS_APP_VERSION) >= 0;
